import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { polymorphicFactory, useProps } from "@coveord/plasma-mantine";
import { IconExternalLink } from "@coveord/plasma-react-icons";
import { Anchor } from "../anchor/Anchor.js";
import { useEmptyStateContext } from "./EmptyStateContext.js";
var defaultProps = {
    icon: IconExternalLink
};
export var EmptyStateLink = polymorphicFactory(function(props, ref) {
    var ctx = useEmptyStateContext();
    var _ref = useProps("EmptyStateLink", defaultProps, props), IconName = _ref.icon, children = _ref.children, classNames = _ref.classNames, className = _ref.className, styles = _ref.styles, style = _ref.style, others = _object_without_properties(_ref, [
        "icon",
        "children",
        "classNames",
        "className",
        "styles",
        "style"
    ]);
    return /*#__PURE__*/ _jsxs(Anchor, _object_spread_props(_object_spread({
        ref: ref
    }, ctx.getStyles("link", {
        classNames: classNames,
        className: className,
        styles: styles,
        style: style
    }), others), {
        children: [
            /*#__PURE__*/ _jsx(IconName, {
                height: 16
            }),
            children
        ]
    }));
});

//# sourceMappingURL=EmptyStateLink.js.map